var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuietZonePoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 18.9379L20.781 13.8814C20.9993 13.6966 21.2659 13.5781 21.5494 13.5398C21.8329 13.5016 22.1213 13.5452 22.3808 13.6655C22.6403 13.7858 22.86 13.9777 23.014 14.2188C23.168 14.4598 23.2499 14.7398 23.25 15.0259V32.9734C23.25 34.2514 21.7545 34.9444 20.781 34.1179L14.8125 29.0614",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 18.9379L20.781 13.8814C20.9993 13.6966 21.2659 13.5781 21.5494 13.5398C21.8329 13.5016 22.1213 13.5452 22.3808 13.6655C22.6403 13.7858 22.86 13.9777 23.014 14.2188C23.168 14.4598 23.2499 14.7398 23.25 15.0259V32.9734C23.25 34.2514 21.7545 34.9444 20.781 34.1179L14.8125 29.0614",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 29.0625H11.25C10.8522 29.0625 10.4706 28.9045 10.1893 28.6232C9.90804 28.3419 9.75 27.9603 9.75 27.5625V20.4375C9.75 20.0397 9.90804 19.6581 10.1893 19.3768C10.4706 19.0955 10.8522 18.9375 11.25 18.9375H14.8125",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 29.0625H11.25C10.8522 29.0625 10.4706 28.9045 10.1893 28.6232C9.90804 28.3419 9.75 27.9603 9.75 27.5625V20.4375C9.75 20.0397 9.90804 19.6581 10.1893 19.3768C10.4706 19.0955 10.8522 18.9375 11.25 18.9375H14.8125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 20.5352L30.125 27.2852",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 27.2852L30.125 20.5352",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuietZonePoi);
export default __webpack_public_path__ + "static/media/quiet-zone-poi.6ae70952d5d1a8d1da5bb81bd2ece1e8.svg";
export { ForwardRef as ReactComponent };